import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSimCard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 72,
	viewBox: "0 0 72 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18 9.77a3.365 3.365 0 0 0-3.364 3.365v46.703A3.365 3.365 0 0 0 18 63.203h36.973a3.365 3.365 0 0 0 3.364-3.365V22.513L45.596 9.77H18Zm-4.5-1.136A6.365 6.365 0 0 1 18 6.77h28.838l14.5 14.5v38.568a6.365 6.365 0 0 1-6.364 6.365H18a6.365 6.365 0 0 1-6.365-6.365V13.135c0-1.688.67-3.307 1.864-4.5Z",
		fill: "#000"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.42 34.986h34.135V58.42H19.419V34.987Zm3 3V55.42h28.135V37.987H22.419Z",
		fill: "#000"
	})]
});
export default SvgSimCard;
